import { createFileRoute, useRouterState } from "@tanstack/react-router"
import { RoleGate } from "@/components/role-gate"
import { SettingsShell } from "@/components/settings-shell"
import { ADMIN_NAV } from "@/lib/admin-nav"

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
})

function AdminLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  if (!pathname.startsWith("/admin")) {
    return null
  }
  return (
    <RoleGate
      role="admin"
      isDeskPath={(p) => p.startsWith("/admin")}
      notAuthorized={
        <div className="mkt-page home-wf">
          <div className="mkt-page-shell py-10">
            <h1 className="mkt-page-title">Not authorized</h1>
            <p className="mt-2 text-sm text-[color:var(--wf-mute)]">
              This area is for platform operators only.
            </p>
          </div>
        </div>
      }
    >
      <SettingsShell title="Admin" items={[...ADMIN_NAV]} />
    </RoleGate>
  )
}
